import React from "react";
import "./App.css";
import { routes } from "@/routes";
import { useRoutes, RouteObject } from "react-router-dom";
function App() {
  const router = useRoutes(routes as RouteObject[]);
  return <>{router}</>;
}

export default App;
